export default __webpack_public_path__ + "static/media/HT.23241d63.svg";